import { Easing, useAnimatedScrollHandler, useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated'

export const useHeaderAnimation = () => {
  const translationY = useSharedValue(0)
  const offsetY = useSharedValue(0)

  const scrollHandler = useAnimatedScrollHandler({
    onScroll: (event) => {
      offsetY.value = event.contentOffset.y
      if (event.contentOffset.y < 5) {
        if (translationY.value === 75) {
          translationY.value = withTiming(0, { duration: 200, easing: Easing.bezier(0.25, 0.1, 0.25, 1) })
        }
      } else {
        if (translationY.value === 0) {
          translationY.value = withTiming(75, { duration: 200, easing: Easing.bezier(0.25, 0.1, 0.25, 1) })
        }
      }
    },
  })

  const translateAnimatedStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          translateY: translationY.value * -1,
        },
      ],
    }
  })

  return { scrollHandler, translationY, translateAnimatedStyle, offsetY }
}
